module.exports = __webpack_public_path__ + "media/music/saw_lead_5-d1f5644f.mp3";